import { Card, Text } from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";

interface SchedulingProviderCardProps {
  name: string;
  description: string;
  buttonLabel: string;
  onSchedule: () => void;
}

export function SchedulingProviderCard(props: SchedulingProviderCardProps) {
  const { name, description, buttonLabel, onSchedule } = props;

  return (
    <Card variant="tertiary" sx={{ minWidth: 280 }}>
      <CardContent>
        <Stack spacing={6}>
          <Stack spacing={4}>
            <Text variant="h6" sx={(theme) => ({ color: theme.palette.text.primary })}>
              {name}
            </Text>
            <Text variant="caption" sx={(theme) => ({ color: theme.palette.text.secondary })}>
              {description}
            </Text>
          </Stack>
          <Button fullWidth variant="outlined" size="small" onClick={onSchedule}>
            {buttonLabel}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
